import React, { useEffect } from "react";
import Metatag from "../../components/Metatag/Metatag";

const PowerUpgrades = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Metatag
        title="Power Upgrades & New Substation Services | DEWA Approvals"
        description="Expand your electrical capacity with Megavolt, a premium DEWA approved contractor. We specialize in power upgrades and dedicated substation installations in Dubai."
        link="powerupgrades"
      />
      <div>
        <div className="text-center items-center mb-10 mt-10">
          <h1 className="text-[34px] font-semibold text-[black]">
            Power <span className="text-[#ffb732] text-[38px]">Upgrades</span>
          </h1>
          <p className="mt-3 text-lg font-medium text-gray-700 px-4">
            Safe Capacity Expansions by a Certified DEWA Approved Contractor
          </p>
        </div>

        <div className="flex-col flex lg:flex-row gap-[19px] sm:gap-10 lg:justify-around sm:w-[85%] sm:mx-auto p-4 mb-20 relative">
          <div className="rounded-xl w-full border-t-[2px] border-[#cbcbcb] lg:p-10 p-5 bg-white" style={{ boxShadow: '0px 2px 25px #7c78754f' }}>
            <p className="text-[#090a0e] text-lg leading-loose mb-6 text-justify">
              As your operations grow, so do your power demands. When your existing electrical supply is insufficient for new machinery, expanded floor space, or increased cooling loads, <strong>Megavolt Technical Services Co. LLC</strong> provides comprehensive power upgrade solutions across the UAE. As a recognized <strong>DEWA approved contractor</strong>, we deliver engineered electrical expansions matched perfectly to your needs.
            </p>
            <p className="text-[#090a0e] text-lg leading-loose mb-8 text-justify">
              Upgrading electrical loads requires rigorous assessments and meticulous <strong>DEWA approvals</strong>. We combine technical expertise in load calculations and substation design with a deep understanding of Dubai authority guidelines to ensure a flawless upgrade trajectory.
            </p>

            <h2 className="text-[#ffb732] text-3xl font-semibold mb-4 border-b-2 border-[#ffb732] inline-block pb-2">Our Power Upgrade Services</h2>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-10">
              <div className="bg-gray-100 p-6 rounded-lg border border-gray-200 shadow-sm">
                <h3 className="font-bold text-xl mb-3 text-black">Electrical Load Upgrades</h3>
                <p className="text-gray-700">Detailed heat load calculations and power layout redesigns to accommodate heavy machinery or increased operational footprints with official <strong>DEWA approval</strong>.</p>
              </div>
              <div className="bg-gray-100 p-6 rounded-lg border border-gray-200 shadow-sm">
                <h3 className="font-bold text-xl mb-3 text-black">New & Upgrade Substation Services</h3>
                <p className="text-gray-700">Strategic design, installation, and modification of Substation and LV Room systems. We help scale industrial and large commercial developments.</p>
              </div>
            </div>

            <div className="bg-gray-50 border border-[#cbcbcb] p-8 rounded-lg mb-10">
              <h3 className="font-bold text-2xl mb-4 text-[#ffb732]">The DEWA Approval Process for Upgrades</h3>
              <p className="mb-4 text-lg text-[#090a0e]">
                Any increase in electrical load must be formally evaluated to prevent straining the municipal grid. Through our <strong>DEWA approval</strong> services, our consultants submit precise load assessments and NOC applications, minimizing bureaucratic delays. Choosing us as your <strong>DEWA approved contractor</strong> ensures you never suffer extended operational halts.
              </p>
            </div>

            <div className="text-center bg-[#f9f9f9] border border-gray-300 p-8 rounded-lg shadow-inner">
              <h2 className="text-[#ffb732] text-3xl font-bold mb-4">Ready to Expand Your Power Output?</h2>
              <p className="text-[#090a0e] text-lg leading-loose mb-4">
                Scale your facilities securely. Contact Megavolt to kickstart your power upgrades and get guaranteed <strong>DEWA approvals</strong> today.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PowerUpgrades;
